<template>
	<v-container>
		<v-page-header :color="$root.colorHeader" :titulo="$root.titleHeader"/>			

		<v-list>
			<v-col class="pt-0 pb-0" cols="2">											
				<v-select
					v-model="anoExercicio"
					:items="anoExercicioItems"
					label="Ano de Exercício" 
					item-text="anoExercicio"
					item-value="anoExercicio"
					no-data-text="Não existem anos cadastrados"
					return-object
				/>
			</v-col>
		</v-list>

		<v-card tile>
			<!-- <v-card-title primary-title v-if="temFuncao('EMENDA_SALVAR')">
				<router-link to="novo" append tag="span">
					<v-tooltip :value="$root.showAtalhos" bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn v-bind="attrs" v-on="on">
								<v-icon color="primary">mdi-plus</v-icon> Nova Emenda
							</v-btn>
						</template>
						<span v-shortkey.once="['alt', 'n']" @shortkey="novo">alt+n</span>
					</v-tooltip>
				</router-link>
			</v-card-title> -->
			<v-row class="ml-4 mr-4">
				<v-col md="2">
					<v-select
						outlined
						v-model="esfera"
						:items="esferaItems"
						label="Esfera"
						item-text="descricao"
						item-value="id"
						return-object
					/>
				</v-col>
				<v-col md="3">
					<v-select
						outlined
						v-model="secretarias"
						:items="secretariaItems"
						label="Secretarias"
						item-text="nome"
						item-value="id"
						no-data-text="Não existem emendas para a secretaria selecionada"
						return-object
					/>
				</v-col>
				<v-col md="4">
					<v-select
						outlined
						v-model="situacoes"
						:items="situacaoItems"
						label="Situacão"
						item-text="descricao"
						item-value="id"
						no-data-text="Não existem emendas para a situação selecionada"
						return-object
					/>
				</v-col>
				<v-col md="2">
					<v-text-field
						outlined
						v-model="numeroEmendaPesq"
						label="Número"
						clearable
					/>
				</v-col>
			</v-row>

			<v-row class="ml-4 mr-4">
				<v-col md="11">
					<v-select
						outlined
						v-model="parlamentares"
						:items="parlamentaresItems"
						label="Parlamentar"
						item-text="nome"
						item-value="id"
						no-data-text="Não existem emendas para o parlamentar selecionado"
						return-object
					/>
				</v-col>
			</v-row>
			
			<v-row class="ml-4 mr-4">
				<v-col md="11">
					<v-text-field
						outlined
						v-model="searchText"
						label="Pesquisa"
						clearable
						autofocus
					/>
				</v-col>
			</v-row>

			<v-data-table
				v-model="emendasSelecionadas"
				show-select
				:headers="headers"
				:items="emendas"
				class="elevation-1 row-pointer"
				@click:row="rowClick"
				:no-data-text="noDataMessage"
				:search="searchText"
				:items-per-page="itemsPerPage"
				:page.sync="page"
				:custom-sort="customSort"
				@pagination="p => (itemsPerPage = p.itemsPerPage)"
				:header-props="{
					sortByText: 'Ordenar por'
				}"
				:footer-props="{
					itemsPerPageText: 'Itens por página:',
					itemsPerPageAllText: 'Todos',
					itemsPerPageOptions: [10, 15, 25, 50, 100, -1]
				}"
				ref="tableEmendas"
				@snack="v => this.$emit('snack',v)"
			>
				<template
					v-slot:[`footer.page-text`]="{ pageStart, pageStop, itemsLength }"
				>
					Exibindo Página de
					{{ Math.floor((pageStart - 1) / itemsPerPage + 1) }} a
					{{ Math.floor(itemsLength / itemsPerPage) + 1 }} <br />
					Itens de {{ pageStart }} a {{ pageStop }} - Total: {{ itemsLength }}
				</template>
			</v-data-table>
			<!-- <v-row class="mr-1 ml-1">
				<v-col offset="8" cols="4">
					<v-spacer></v-spacer>
					<v-btn
						block
						color="primary"
						@click="clickTramitar(emendasSelecionadas)"
						:disabled="emendasSelecionadas.length == 0"
					>
						Tramitar {{ emendasSelecionadas.length }} selecionada{{
							emendasSelecionadas.length > 1 ? 's' : ''
						}}
					</v-btn>
				</v-col>
			</v-row> -->
		</v-card>
		<v-bottom-sheet persistent width="70%" v-model="exibirTramitacao">
			<v-sheet class="text-center">
				<v-col md="12">
					<v-form v-model="despachoValido" ref="formDespacho">
						<v-textarea
							autofocus
							v-model="despacho"
							label="Favor informar despacho:"
							rows="3"
							filled
							background-color="blue lighten-5"
							auto-grow
							counter
							required
							:rules="[
								$rules.required(),
								$rules.conterEspaco({
									msg: 'O despacho deve conter mais de uma palavra.'
								})
							]"
							maxlength="1000"
						/>
					</v-form>
				</v-col>
				<v-col md="12">
					<v-select v-if="situacaoFluxoDestinoItems"
						v-model="despachoSituacao"
						:rules="[$rules.required()]"
						:items="situacaoFluxoDestinoItems"
						label="Situação da Emenda"
						item-text="emendaSituacaoDestino.descricao"
						item-value="emendaSituacaoDestino.id"
						filled
						background-color="blue lighten-5"
						required
						return-object
					/>
				</v-col>
				<v-row
					v-if="emendasSelecionadasSituacao.length > 0 && despachoSituacao"
				>
					<v-col md="12">
						<div
							class="info-despacho"
							v-if="emendasSelecionadasSituacao.length > 1"
						>
							As emendas
							<span
								class="emendas"
								v-for="(emendaSituacao, index) in emendasSelecionadasSituacao"
								:key="emendaSituacao.id"
								>{{ index > 0 ? ',' : '' }} {{ emendaSituacao.numeroEmenda }}/{{
									emendaSituacao.anoExercicio
								}}
								({{ emendaSituacao.esfera }})</span
							>
							já possuem situação em
							<span class="situacao">{{ despachoSituacao.descricao }}</span
							>, sendo assim nao serão realizadas tramitações para essas
							emendas.
						</div>
						<div class="info-despacho" v-else>
							A emenda
							<span
								class="emendas"
								v-for="emendaSituacao in emendasSelecionadasSituacao"
								:key="emendaSituacao.id"
								>{{ emendaSituacao.numeroEmenda }}/{{
									emendaSituacao.anoExercicio
								}}
								({{ emendaSituacao.esfera }})</span
							>
							já possui situação em
							<span class="situacao">{{ despachoSituacao.descricao }}</span
							>, sendo assim nao será realizada tramitação para essa emenda.
						</div>
					</v-col>
				</v-row>
				<v-row>
					<v-col md="12">
						<v-btn
							class="mr-5"
							outlined
							v-shortkey.once="['esc']"
							@shortkey="cancelarTramitacao"
							@click="cancelarTramitacao"
						>
							Cancelar
						</v-btn>
						<v-btn
							outlined
							v-shortkey.once="['ctrl', 'enter']"
							@shortkey="tramitar"
							color="primary"
							@click="tramitar"
						>
							Tramitar
						</v-btn>
					</v-col>
				</v-row>
			</v-sheet>
		</v-bottom-sheet>
	</v-container>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import VPageHeader from '@/components/PageHeader.vue';

export default {
	name: 'Home',
	data() {
		return {
			searchText: null,
			emendas: [],
			emendasSelecionadas: [],
			loading: false,
			headers: [
				{ text: 'Nr.', value: 'numeroEmenda' },
				{ text: 'Ano', value: 'anoExercicio' },
				{ text: 'Descrição', value: 'descricao' },
				{ text: 'Secretaria destino', value: 'secretaria.sigla' },
				{ text: 'Parlamentar', value: 'nomeParlamentar' },
				{ text: 'Situação', value: 'situacao.descricao' },
				{ text: 'Esfera', value: 'esfera' },
				{ text: 'Valor da Emenda (R$)', value: 'valor$' },
				{ text: 'Valor Fixado Final (R$)', value: 'valorFixadoFinal$' }
			],
			noDataMessage:
				'Não foram encontradas emendas para o exercício.',
			itemsPerPage: 10,
			page: 1,

			esfera: null,
			anoExercicio: null,
			secretarias: null,
			situacoes: null,

			esferaItems: [],
			anoExercicioItems: [],
			secretariaItems: [],
			situacaoItems: [],

			exibirTramitacao: false,
			despachoValido: null,
			despacho: null,
			novaSituacao: null,
			situacaoFluxoDestinoItems: null,
			despachoSituacao: null,

			numeroEmendaPesq : null,

			parlamentares: null,
			parlamentaresItems: []
		};
	},
	components: {VPageHeader},
	async created() {
		this.fetchEsferaItems();
		//this.fetchSituacoesItems();     //??
		this.fetchSecretarias();
		this.fetchSituacoes();
		this.fetchParlamentares();

		this.$root.colorHeader = "blue";
		this.$root.titleHeader = "Listagem de Emendas";

		this.fetchAnos();

		//this.anoExercicio = this.$root.anoSelecionado;
	},


	computed: {
		emendasSelecionadasSituacao() {
			if (this.despachoSituacao && this.despachoSituacao.id) {
				return this.emendasSelecionadas.filter(
					e => e.situacao.id == this.despachoSituacao.id
				);
			}

			return [];
		}
	},
	watch: {
		// esfera(val) {
		// 	let id = val && val.id;
		// 	this.fetchAnos(id);
		// },

		// anoExercicio() {
		// 	this.$root.anoSelecionado = this.anoExercicio.anoExercicio;
		// 	localStorage.setItem('anoSelecionado', JSON.stringify(this.anoExercicio.anoExercicio));
		// 	this.$router.push('/emendas');
		// },

		// '$root.anoSelecionado'() {
		// 	this.anoExercicio = this.$root.anoSelecionado;
		// 	this.fetchEmendas();
		// },

		esfera() {
			this.fetchEmendas();
		},
		anoExercicio() {
			this.fetchEmendas();
		},
		secretarias() {
			this.fetchEmendas();
		},
		situacoes() {
			this.fetchEmendas();
		},
		numeroEmendaPesq() {
			this.fetchEmendas();
		},
		parlamentares() {
			this.fetchEmendas();
		},
		searchText() {
			this.page = 1;
		}
	},
	methods: {
		novo() {
			this.$router.push('/emendas/novo');
		},
		rowClick(item) {
			this.$router.push(`/emendas/${item.id}`);
		},
		async fetchEmendas() {
			try {
				let emendas = await this.$fetch.get('emendas', {
					anoExercicio: this.anoExercicio.anoExercicio,
					idEsfera: this.esfera ? this.esfera.id : null,
					idSecretaria: this.secretarias ? this.secretarias.id : null,
					idSituacao: this.situacoes ? this.situacoes.id : null,
					nrEmenda: this.numeroEmendaPesq ? this.numeroEmendaPesq : null ,
					idParlamentarExercicio : this.parlamentares ? this.parlamentares.id : null
				});
				
				emendas.forEach(emenda => {
					emenda.valor$ = this.setMascara(emenda.valor);
					emenda.valorFixadoFinal$ = this.setMascara(emenda.valorFixadoFinal);
					if (
						this.$root.usuarioLogado &&
						this.$root.usuarioLogado.funcoes &&
						this.$root.usuarioLogado.funcoes.includes('EMENDA_ALTERAR')
					) {
						emenda.isSelectable = true;
					} else if (emenda.situacao.id === 3) {
						emenda.isSelectable = true;
					} else {
						emenda.isSelectable = false;
					}
				});
				this.emendas = emendas;

			} catch (err) {
				this.noDataMessage = err.msg;
			}
		},
		async fetchEsferaItems() {
			try {
				this.esferaItems = await this.$fetch.get('parlamentares/esferas');
				this.esferaItems.splice(0, 0, { id: null, descricao: 'Todos' });
				this.esfera = this.esferaItems[0];
			} catch (err) {
				this.$root.dialog = {
					title: 'Não foi possível carregar esferas',
					msg: err.msg
				};
			}
		},

		// async fetchSituacoesItems() {
		// 	try {
		// 		this.situacaoItems = await this.$fetch.get('emendas/situacoes');
		// 	} catch (err) {
		// 		this.$root.dialog = {
		// 			title: 'Não foi possível carregar situações',
		// 			msg: err.msg
		// 		};
		// 	}
		// },

		async fetchSituacoesDestinoItems(idFluxoOrigem) {
			try {
				this.situacaoFluxoDestinoItems = await this.$fetch.get('emendas/situacoesFluxoDestino', {
					idFluxoOrigem
			});
			} catch (err) {
				this.$root.dialog = {
					title: 'Não foi possível carregar situações',
					msg: err.msg
				};
			}
		},

		// async fetchAnos(idEsfera) {
		// 	this.anoExercicioItems = await this.$fetch.get('emendas/anos', {
		// 		idEsfera
		// 	});
		// 	this.anoExercicioItems.splice(0, 0, { anoExercicio: 'Todos' });
		// 	this.anoExercicio = this.anoExercicioItems[0];
		// 	this.fetchEmendas();
		// },

		async fetchSecretarias() {
			this.secretariaItems = await this.$fetch.get('emendas/secretarias');
			// if (this.$root.usuarioLogado &&
			// 		this.$root.usuarioLogado.perfis &&
			// 		this.$root.usuarioLogado.perfis.includes('Administrador')) {
				this.secretariaItems.splice(0, 0, { id: null, nome: 'Todas' });
			// }
			this.secretarias = this.secretariaItems[0];
			this.fetchEmendas();
		},

		async fetchSituacoes() {
			this.situacaoItems = await this.$fetch.get('emendas/situacoes');
			this.situacaoItems.splice(0, 0, { id: null, descricao: 'Todas' });
			// if (this.$root.usuarioLogado &&
			// 		this.$root.usuarioLogado.perfis &&
			// 		this.$root.usuarioLogado.perfis.includes('Administrador')) {
				this.situacoes = this.situacaoItems[0];
			// }
			// else
			// 	this.situacoes = this.situacaoItems.find( a => a.id === 3 );
			this.fetchEmendas();
		},

		async fetchParlamentares() {
			this.parlamentaresItems = await this.$fetch.get('emendas/parlamentares');

			for (let index = 0; index < this.parlamentaresItems.length - 1; index++) {
				this.parlamentaresItems[index].nome = 
					this.parlamentaresItems[index].nome  + ' - ' +
					this.parlamentaresItems[index].dataInicio + ' a ' +
					this.parlamentaresItems[index].dataFim;
			}

			this.parlamentaresItems.splice(0, 0, { id: null, nome: 'Todos' });
			// if (this.$root.usuarioLogado &&
			// 		this.$root.usuarioLogado.perfis &&
			// 		this.$root.usuarioLogado.perfis.includes('Administrador')) {
				this.parlamentares = this.parlamentaresItems[0];
			// }
			// else
			// 	this.situacoes = this.situacaoItems.find( a => a.id === 3 );
			this.fetchEmendas();
		},

		setMascara(v) {
			if (v >= 0) {
				return v.toLocaleString('pt-BR', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
					style: 'currency',
					currency: 'BRL'
				});
			}
			return '-';
		},

		customSort(items, index, isDesc) {
			items.sort((a, b) => {
				if (index[0] && index[0].slice(-1) === '$') {
					if (!isDesc[0]) {
						return a[index[0].slice(0, -1)] < b[index[0].slice(0, -1)] ? -1 : 1;
					} else {
						return b[index[0].slice(0, -1)] < a[index[0].slice(0, -1)] ? -1 : 1;
					}
				} else if (a[index]) {
					if (!isDesc[0]) {
						return a[index] < b[index] ? -1 : 1;
					} else {
						return b[index] < a[index] ? -1 : 1;
					}
				}
				else {
					// campos "filhos" tem que fazer a ordenação na mão
					if ((index[0] == 'situacao.descricao') || (index[0] == 'secretaria.sigla'))
					{
						var campoA, campoB, ordem;

						if (index[0] == 'situacao.descricao')
						{
							campoA = a['situacao'];
							campoB = b['situacao'];

							ordem = 'descricao';
						}

						if (index[0] == 'secretaria.sigla')
						{
							campoA = a['secretaria'];
							campoB = b['secretaria'];

							ordem = 'sigla'
						}

						if (!isDesc[0]) {
							return campoA[ordem].toLowerCase().localeCompare(campoB[ordem].toLowerCase());
						} else
						{
							return campoB[ordem].toLowerCase().localeCompare(campoA[ordem].toLowerCase());
						}
					}
				}
			});

			return items;
		},

		//async clickTramitar(emendasSelecionadas) {

			//let situacaoEmendas = [];

			// montar uma array só com o campo situação
			//emendasSelecionadas.forEach((sit) => { situacaoEmendas.push(sit.situacao.id) });

			// verificando se foram selecionadas emendas com situações diferentes
			// var idSituacao = situacaoEmendas.filter(function(elem, pos, arr) {
			// 	return arr.indexOf(elem) == pos;
			// });

			//let mesmaSituacao = (idSituacao.length === 1); 
			
			// if (mesmaSituacao)
			// {
			// 	if ( (emendasSelecionadas.length == 1) || ( (this.$root.usuarioLogado &&
			// 			this.$root.usuarioLogado.funcoes &&
			// 			this.$root.usuarioLogado.funcoes.includes('EMENDA_ALTERAR')) ) ) {
			// 		this.fetchSituacoesDestinoItems(idSituacao);
			// 		this.exibirTramitacao = true;
			// 	} else {
			// 		this.$root.dialog = { title: 'Tramitação não permitida', msg: 'Selecione somente uma emenda para tramitação por vez.' };
			// 	}
			// }
			// else {
			// 	this.$root.dialog = { title: 'Tramitação não permitida', msg: 'Selecione somente emendas na mesma situação.' };
			// }

		//},

		async tramitar() {
			await this.$refs.formDespacho.validate();

			if (this.despachoValido) {
				let emendasTramitar = this.emendasSelecionadas
					.filter(e => e.situacao.id !== this.despachoSituacao.id)
					.map(e => e.id);
				let tramitacao = {
					despacho: this.despacho,
					emendasTramitar,
					situacao: this.despachoSituacao
				};

				this.exibirTramitacao = false;

				try {
					let qtdEmendasSalvas = await this.$fetch.post(
						`emendas/tramitar`,
						tramitacao
					);

					this.$emit('snack', {
						show: true,
						text: `${qtdEmendasSalvas} emendas tramitadas com sucesso para ${this.despachoSituacao.descricao}`
					});

					await this.resetTramitacao();

					this.fetchEmendas();
				} catch (err) {
					this.$root.dialog = { title: 'Emenda não salva', msg: err.msg };
				}
			}
		},

		async cancelarTramitacao() {
			await this.resetTramitacao();

			this.exibirTramitacao = false;
		},

		async resetTramitacao() {
			this.despacho = null;
			this.despachoSituacao = null;
			await this.$refs.formDespacho.reset();
		},

		temFuncao(fn) {
			return (
				this.$root.usuarioLogado &&
				this.$root.usuarioLogado.funcoes &&
				this.$root.usuarioLogado.funcoes.includes(fn)
			);
		},

		fetchAnos() {
			var year = new Date().getFullYear();

			for (let index = year-5; index <= year+2; index++) {
				this.anoExercicioItems.push({ anoExercicio: index });				
			}

			this.anoExercicio = this.anoExercicioItems.find(e => e.anoExercicio == year);
		}
	}
};
</script>

<style scoped>
.head-tile {
	margin: -10px -10px 0 -10px;
}
.row-pointer >>> tbody tr :hover {
	cursor: pointer;
}
.situacao {
	font-weight: bold;
	color: orangered;
}
.emendas {
	font-weight: bold;
	color: purple;
}
.info-despacho {
	text-align: center;
	font-size: 80%;
}
</style>
